import { useQuery, gql } from "@apollo/client"
import { offsetLimitPagination } from "@apollo/client/utilities"

const TIMESHEETS_LIMIT = 10

const TIMESHEET_LIST_FIELDS = `
  id
  startedAt
  endedAt
  status
  secondsOnBreak
  createdAt
  updatedAt
  user {
    id
    fullName
  }
  location {
    id
    name
    timeZone
  }
  shift {
    id
    startsAt
    endsAt
  }
  group {
    id
    name
  }
`

const TIMESHEETS_QUERY = gql`
  query TimesheetsList($filter: TimesheetsFilterInput, $limit: Int = ${TIMESHEETS_LIMIT}, $offset: Int) {
    timesheets {
      list(filter: $filter, limit: $limit, offset: $offset) {
        ${TIMESHEET_LIST_FIELDS}
      }
      count(filter: $filter)
    }
  }
`

const computeListCacheKey = (args) => JSON.stringify(args.filter)

const timesheetsTypePolicies = {
  scoped: {
    TimesheetsQuery: {
      merge(prev, next) {
        return {
          ...(prev || {}),
          ...next
        }
      },
      fields: {
        list: offsetLimitPagination(computeListCacheKey),
        count: {
          keyArgs: computeListCacheKey
        }
      }
    }
  }
}

const useQueryTimesheetsList = (options) => useQuery(TIMESHEETS_QUERY, options)

export { useQueryTimesheetsList, timesheetsTypePolicies }
